class Core {

  constructor() {

    new Header()
    // new HideScroll()
    new Menu()
    new Popups()
    new TextWrap()

    new WeatherList()
    new CommentsList()
    new DatingStats()
    new EventsList()
    new HotNot()
    new MatchBox()
    new MessagesList()
    new Newsletter()
    new PhotosBattle()
    new PlanBox()
    new PollBox()
    new Spotted()

    //new Lightbox()
    new Comments()
    new CommentsForm()
    new VideoPlayer()
  }

}

let domReady = callback => {

  if ((document.readyState === 'interactive') || (document.readyState === 'complete'))
    callback()
  else
    document.addEventListener('DOMContentLoaded', callback)

}

domReady(() => new Core())
